import { h } from 'preact'
import classNames from 'classnames'

type Props = {
    success?: boolean,
    secondary?: boolean,
    text: string
}
const Flag = ({ success, secondary, text }: Props) => {
  return <div class={classNames({
    'preact-flag': true,
    'preact-flag-success': success,
    'preact-flag-secondary': secondary
  })}>{text}</div>
}

export default Flag
